import { Paper, Text, Title } from "@mantine/core";
import { EditIcon } from "../../shared/svg";
import "./Profile.scss";
import useProfileStore from "../../store/useProfileStore";
import useAuthStore from "../../store/useAuthStore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const Education = () => {
  const { profile } = useProfileStore();
  const education = profile?.educations || [];
  const { cvProcessing } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const formatDate = (
    date?: { day?: number; month?: number; year?: number } | null
  ): string => {
    if (!date) return "";

    const { month, year } = date;

    if (year && month) {
      const formattedMonth = month.toString().padStart(2, "0");
      return `${formattedMonth}.${year}`;
    }

    if (year) {
      return `${year}`;
    }

    return "";
  };

  return (
    <Paper withBorder radius="24px" p={32} h="100%" pos="relative">
      <div
        className="edit-icon"
        onClick={() => navigate("/profile/edit/education")}
      >
        <EditIcon />
      </div>
      <Title size={36} lh="50px">
        {t("education")}
      </Title>

      {education.length > 0 ? (
        education.map((item, index) => {
          const start = formatDate(item.start_date);
          const end = formatDate(item.end_date);
          const dateRange =
            start && end ? `${start} - ${end}` : start || end || "";

          return (
            <div key={index}>
              <Title
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  maxWidth: "100%",
                }}
                size={24}
                mt={40}
              >
                {item.field_of_study || item.degree || t("unknown")}
              </Title>
              <Text
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  maxWidth: "100%",
                }}
                mt={8}
              >
                {item.institution}
              </Text>
              {dateRange && (
                <Text mt={8} c="#737373">
                  {dateRange}
                </Text>
              )}
            </div>
          );
        })
      ) : (
        <Text mt={30} c="#737373">
          {cvProcessing !== "processing"
            ? t("no_education")
            : t("no_education_cv")}
        </Text>
      )}
    </Paper>
  );
};
